module.exports = __webpack_public_path__ + "img/1723596567892-image.jpg.6cf9a86c.webp";